import React from "react";
import "../assets/styles/Timeline.scss";

const GROUPS = [
  {
    year: "2026",
    jobs: [
      {
        title: "Founder",
        current: true,
        org: "Voint — İyuldan",
        tags: "Fullstack · Startup · Məhsul İnkişafı",
      },
      {
        title: "Head of Product",
        current: true,
        org: "Construction Equipment Services — Yanvardan",
        tags: "Komanda Qurulması · Məhsul Strategiyası · Yol Xəritəsi · Rəqabət Analizi",
      },
    ],
  },
  {
    year: "2025",
    jobs: [
      {
        title: "IT Project Manager",
        current: false,
        org: "Martech — 2025 Avqust - 2026 İyul",
        tags: "Prioritetləşdirmə · Vaxt İdarəsi · Scrum · Kanban",
      },
      {
        title: "IT Project Manager",
        current: false,
        org: "Bendis Platforması — İyun · Sentyabr",
        tags: "Agile · API İnteqrasiya · Ödəniş Həlləri · Startup Mühiti",
      },
      {
        title: "Tech Lead",
        current: false,
        org: "4SİM (C4IR) — Aprel · 2026 Yanvar",
        tags: "Liderlik · Backend Development · Mentorluq",
      },
    ],
  },
];

function Timeline() {
  return (
    <section id="history" className="career">
      <div className="sec-head" data-reveal>
        <span className="sec-num" aria-hidden="true">
          03
        </span>
        <h2 className="sec-title">Karyera</h2>
      </div>

      {GROUPS.map((group) => (
        <div className="career-group" key={group.year} data-reveal>
          <div className="career-year">
            <span aria-hidden="true">{group.year}</span>
          </div>
          <div className="career-jobs">
            {group.jobs.map((job, i) => (
              <div className="career-job" key={`${group.year}-${i}`}>
                <div className="job-top">
                  <span className="job-title">{job.title}</span>
                  {job.current && <span className="job-badge">davam edir</span>}
                </div>
                <div className="job-org">{job.org}</div>
                <div className="job-tags">{job.tags}</div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </section>
  );
}

export default Timeline;
